import { InstallMeterStep } from 'routes/installation/enums/installMeterStep';
import { InstallMeterStore } from 'routes/installation/useStore';
import { isThermometer } from 'utils/isThermometer';

export const selectIsInstallMeterSensorStepOK: (state: InstallMeterStore) => boolean = (state: InstallMeterStore) =>
  !state.dataSourceId;

export const selectIsInstallMeterDetailStepOK: (state: InstallMeterStore) => boolean = (state: InstallMeterStore) => {
  const { enmonMeter, validSteps } = state;
  // meters of type Other with device category Thermometers skip this step
  if (isThermometer(enmonMeter?.detail)) {
    return true;
  }

  return validSteps[InstallMeterStep.InstallationDetail] ?? false;
};
